import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

import { botTestModeSelector } from '../selectors/botTestModeSelector'

export function useBotTestMode() {
  return useSelector<RootState, boolean>(botTestModeSelector)
}
